export default "__VITE_ASSET__d5256e35__"